import { displayPage, Page } from '../utils/navigation';
export const loadAccountPage = () => {
    displayPage(Page.ACCOUNT);
};
